import inputBaseClasses from "../InputBase/inputBaseClasses";
import { generateUtilityClasses, generateUtilityClass } from "@suid/base";
export function getFilledInputUtilityClass(slot) {
    return generateUtilityClass("MuiFilledInput", slot);
}
const filledInputClasses = {
    ...inputBaseClasses,
    ...generateUtilityClasses("MuiFilledInput", ["root", "underline", "input"]),
};
export default filledInputClasses;
